import React, { useState, useEffect, ChangeEvent, FocusEvent } from 'react';
// @ts-ignore
import MaskedInput from 'react-text-mask';
import moment from 'moment';
import {FaRegCalendar} from "react-icons/fa6";

interface DateInputFieldForHeaderProps {
    date: string | Date | null;
    handleDateChange: any;
    editable: boolean;
}

// Convert ISO date string to MM-DD-YYYY format
const formatDateToMMDDYYYY = (dateString: string | Date | null): string => {
    if (!dateString) return '';
    return moment.utc(dateString).local().format('MM-DD-YYYY');
};

// Convert MM-DD-YYYY format to ISO date string
const formatMMDDYYYYToISO = (dateString: string): string => {
    return moment(dateString, 'MM-DD-YYYY').local().format();
};

// Validate the MM-DD-YYYY date format
const validateDate = (dateString: string): boolean => {
    const [month, day, year] = dateString.split('-').map(Number);

    if (year < 1950 || year > 9999) return false;
    if (month < 1 || month > 12) return false;

    const daysInMonth = new Date(year, month, 0).getDate();
    return day >= 1 && day <= daysInMonth;
};

const DateInputFieldForHeader: React.FC<DateInputFieldForHeaderProps> = ({ date, handleDateChange, editable }) => {
    const [inputDate, setInputDate] = useState<string>(() => {
        return date ? formatDateToMMDDYYYY(date) : 'MM-DD-YYYY';
    });

    const [error, setError] = useState<string>('');

    useEffect(() => {
        if (date) {
            setInputDate(formatDateToMMDDYYYY(date));
        }
    }, [date]);

    const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setInputDate(value);
        if (validateDate(value)) {
            setError('');
            handleDateChange({ target: { value: formatMMDDYYYYToISO(value) } });
        } else {
            setError('Invalid date');
        }
    };

    const onBlur = (_e: FocusEvent<HTMLInputElement>) => {
        if (!validateDate(inputDate)) {
            setError('Invalid date');
        }
    };

    return (
        <>
            <div
                className={`relative min-h-[37px] p-[5px] rounded border ${
                    editable
                        ? 'bg-text-0 border-surface-5'
                        : 'bg-surface-5 border-surface-5 pointer-events-none'
                }`}
            >
                <div className="text-left relative">
                    {editable && (
                        <div className="absolute right-[3px] top-[3px]">
                            {/*<FaRegCalendar/>*/}
                            <i className="fa fa-calendar absolute right-0 w-[21px] h-[25px] text-text-7"></i>
                            <input
                                type="date"
                                value={date ? moment.utc(date).local().format('YYYY-MM-DD') : ''}
                                disabled={!editable}
                                onChange={handleDateChange}
                                onKeyDown={(e) => e.preventDefault()}
                                className="absolute p-0 w-[21px] right-[5px] border-none focus:outline-none focus:shadow-none opacity-0 text-text-7"
                            />
                        </div>
                    )}

                    <MaskedInput
                        mask={[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                        placeholder="MM-DD-YYYY"
                        value={inputDate}
                        onChange={onInputChange}
                        onBlur={onBlur}
                        guide={false}
                        disabled={!editable}
                        className="w-[75%] bg-transparent pl-[8px] relative left-0 opacity-100 text-text-7"
                        style={{pointerEvents: editable ? 'auto' : 'none'}}
                    />
                </div>
            </div>

            {error && <span style={{fontSize: "12px", color: "red"}}>{error}</span>}
        </>
    );
};

export default DateInputFieldForHeader;
